export interface INotaryDetailsData {
  id: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  pictureUrl?: string;
  vehicleMake?: string;
  vehicleModel?: string;
  vehicleLicensePlate?: string;
}

export const getDisplayVehicleInfo = ({ vehicleMake, vehicleModel, vehicleLicensePlate }: INotaryDetailsData): string => {
  const make = vehicleMake ? `${vehicleMake} ` : '';
  const model = vehicleModel ? `${vehicleModel} ` : '';
  const plate = vehicleLicensePlate ? `(${vehicleLicensePlate})` : '';
  return `${make}${model}${plate}`.trim();
}